import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import '../style/Navbar.css';
import banner from '../assets/banner.png';

const Navbar = (props: { isLoggedIn: boolean }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const NavbarMenu = ({ onClose }: { onClose: () => void }) => {
    return (
      <div className='navbar-menu'>
        <Link to='/' className={`navbar-btn ${isActive('/') ? 'active' : ''}`}>
          Home
        </Link>
        <Link
          to='/services'
          className={`navbar-btn ${isActive('/services') ? 'active' : ''}`}
        >
          Services
        </Link>
        <Link
          to='/pricing'
          className={`navbar-btn ${isActive('/pricing') ? 'active' : ''}`}
        >
          Pricing
        </Link>
        <Link
          to='/contact'
          className={`navbar-btn ${isActive('/contact') ? 'active' : ''}`}
        >
          Contact
        </Link>
        <div
          className={`navbar-btn close-btn`}
          onClick={() => {
            setIsMenuOpen(false);
          }}
        >
          Close
        </div>
      </div>
    );
  };

  return (
    <nav className='navbar'>
      <div className='navbar-left'>
        <Link to='/' className='navbar-logo-link'>
          <img src={banner} alt='logo' className='navbar-logo' />
        </Link>
        <div className='navbar-left-buttons'>
          <Link to='/' className={`navbar-btn ${isActive('/') ? 'active' : ''}`}>
            Home
          </Link>
          <Link
            to='/services'
            className={`navbar-btn ${isActive('/services') ? 'active' : ''}`}
          >
            Services
          </Link>
          <Link
            to='/pricing'
            className={`navbar-btn ${isActive('/pricing') ? 'active' : ''}`}
          >
            Pricing
          </Link>
          <Link
            to='/contact'
            className={`navbar-btn ${isActive('/contact') ? 'active' : ''}`}
          >
            Contact
          </Link>
        </div>
      </div>
      <div className='navbar-right'>
        <div className='navbar-right-buttons'>
          {props.isLoggedIn ? (
            <>
              <Link to='/logout' className='navbar-btn-minor'>
                Logout
              </Link>
              <Link
                to='/profile'
                className={`navbar-btn ${isActive('/profile') ? 'active' : ''}`}
              >
                Profile
              </Link>
            </>
          ) : null}
          <Link to='/profile' className='navbar-login'>
            <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor'>
              <circle cx='12' cy='8' r='4' />
              <path d='M12 14c-6 0-8 3-8 3v3h16v-3s-2-3-8-3z' />
            </svg>
          </Link>
        </div>

        <button
          className={`navbar-menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <i className={`fa-solid fa-bars-staggered menu-icon`} />
          ) : (
            <i className={`fa-solid fa-bars menu-icon`} />
          )}
        </button>

        {isMenuOpen && <NavbarMenu onClose={() => setIsMenuOpen(false)} />}
      </div>
    </nav>
  );
};

export default Navbar;
